import React from "react";
import { Bus, Car, Plane, Hotel, TrainFront, ArrowRight } from "lucide-react";
import { SERVICES } from "../mock/mock";
import { Link } from "react-router-dom";

const iconMap = { Bus, Car, Plane, Hotel, TrainFront };

const Services = () => {
  return (
    <section id="services" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-100 text-teal-700 text-xs font-semibold tracking-wider uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-teal-600" /> Our Services
          </div>
          <h2 className="mt-4 text-3xl md:text-5xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Everything you need for a perfect journey
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            One platform, four powerful services. From doorstep pickup to five-star stays — we handle every mile so you can enjoy every moment.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {SERVICES.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={s.id}
                className="group relative bg-white rounded-2xl overflow-hidden border border-slate-200 hover:border-teal-500 hover:shadow-2xl hover:shadow-teal-500/10 hover:-translate-y-1 transition duration-300"
                style={{ animationDelay: `${i * 100}ms` }}
              >
                <div className="relative h-44 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-110 transition duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 to-transparent" />
                  <div className="absolute top-4 left-4 w-11 h-11 rounded-xl bg-white/95 backdrop-blur flex items-center justify-center shadow-lg">
                    <Icon className="w-5 h-5 text-teal-700" />
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-lg text-slate-900">{s.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                  <div className="mt-4 flex items-center gap-2">
                    <Link
                      to="/contact"
                      className="flex-1 inline-flex items-center justify-center gap-1 px-3 py-2 rounded-md text-xs font-semibold border border-teal-600 text-teal-700 hover:bg-teal-50 transition"
                    >
                      Enquire Now
                    </Link>
                    <Link
                      to="/packages"
                      className="flex-1 inline-flex items-center justify-center gap-1 px-3 py-2 rounded-md text-xs font-semibold bg-orange-500 hover:bg-orange-600 text-white transition"
                    >
                      Book Now <ArrowRight className="w-3 h-3" />
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
